var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-chart",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _c("canvas", {
                    ref: "chartCanvas",
                    staticClass: "cw-chart-block-canvas",
                  }),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Beschriftung")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentLabel,
                                    expression: "currentLabel",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.currentLabel,
                                },
                                on: {
                                  focusout: _vm.buildChart,
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.currentLabel = $event.target.value
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Typ")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentType,
                                      expression: "currentType",
                                    },
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentType = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "bar",
                                      },
                                    },
                                    [
                                      _c("translate", [
                                        _vm._v("Säulendiagramm"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "horizontalBar",
                                      },
                                    },
                                    [
                                      _c("translate", [
                                        _vm._v("Balkendiagramm"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "pie",
                                      },
                                    },
                                    [
                                      _c("translate", [
                                        _vm._v("Kreisdiagramm"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "doughnut",
                                      },
                                    },
                                    [_c("translate", [_vm._v("Ringdiagramm")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "polarArea",
                                      },
                                    },
                                    [
                                      _c("translate", [
                                        _vm._v("Polardiagramm"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "line",
                                      },
                                    },
                                    [
                                      _c("translate", [
                                        _vm._v("Liniendiagramm"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.currentContent, function (item, index) {
                            return _c(
                              "fieldset",
                              {
                                key: index,
                              },
                              [
                                _c(
                                  "legend",
                                  [
                                    _c("translate", [_vm._v("Datensatz")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(index + 1) +
                                        "\n                        "
                                    ),
                                    !_vm.onlyRecord
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "cw-block-chart-item-remove",
                                            attrs: {
                                              title: _vm.textRecordRemove,
                                            },
                                            on: {
                                              click: function click($event) {
                                                return _vm.removeItem(index)
                                              },
                                            },
                                          },
                                          [
                                            _c("studip-icon", {
                                              attrs: {
                                                shape: "trash",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  [
                                    _c("translate", [_vm._v("Wert")]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: item.value,
                                          expression: "item.value",
                                        },
                                      ],
                                      attrs: {
                                        type: "number",
                                      },
                                      domProps: {
                                        value: item.value,
                                      },
                                      on: {
                                        change: _vm.buildChart,
                                        input: function input($event) {
                                          if ($event.target.composing) {
                                            return
                                          }

                                          _vm.$set(
                                            item,
                                            "value",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  [
                                    _c("translate", [_vm._v("Bezeichnung")]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: item.label,
                                          expression: "item.label",
                                        },
                                      ],
                                      attrs: {
                                        type: "text",
                                      },
                                      domProps: {
                                        value: item.label,
                                      },
                                      on: {
                                        focusout: _vm.buildChart,
                                        input: function input($event) {
                                          if ($event.target.composing) {
                                            return
                                          }

                                          _vm.$set(
                                            item,
                                            "label",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  [
                                    _c("translate", [_vm._v("Farbe")]),
                                    _vm._v(" "),
                                    _c("studip-select", {
                                      attrs: {
                                        options: _vm.colors,
                                        reduce: function reduce(colors) {
                                          return colors.value
                                        },
                                        label: "rgb",
                                        clearable: false,
                                      },
                                      on: {
                                        "option:selected": _vm.buildChart,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "open-indicator",
                                            fn: function fn(selectAttributes) {
                                              return [
                                                _c(
                                                  "span",
                                                  _vm._b(
                                                    {},
                                                    "span",
                                                    selectAttributes,
                                                    false
                                                  ),
                                                  [
                                                    _c("studip-icon", {
                                                      attrs: {
                                                        shape: "arr_1down",
                                                        size: "10",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "no-options",
                                            fn: function fn() {
                                              return [
                                                _c("translate", [
                                                  _vm._v(
                                                    "Es steht keine Auswahl zur Verfügung."
                                                  ),
                                                ]),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "selected-option",
                                            fn: function fn(_ref) {
                                              var name = _ref.name,
                                                rgb = _ref.rgb
                                              return [
                                                _c("span", {
                                                  staticClass:
                                                    "vs__option-color",
                                                  style: {
                                                    "background-color":
                                                      "rgb(" + rgb + ")",
                                                  },
                                                }),
                                                _c("span", [
                                                  _vm._v(_vm._s(name)),
                                                ]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "option",
                                            fn: function fn(_ref2) {
                                              var name = _ref2.name,
                                                rgb = _ref2.rgb
                                              return [
                                                _c("span", {
                                                  staticClass:
                                                    "vs__option-color",
                                                  style: {
                                                    "background-color":
                                                      "rgb(" + rgb + ")",
                                                  },
                                                }),
                                                _c("span", [
                                                  _vm._v(_vm._s(name)),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: item.color,
                                        callback: function callback($$v) {
                                          _vm.$set(item, "color", $$v)
                                        },
                                        expression: "item.color",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button add",
                          on: {
                            click: _vm.addItem,
                          },
                        },
                        [_c("translate", [_vm._v("Datensatz hinzufügen")])],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c(
                    "p",
                    [
                      _c("translate", [
                        _vm._v("Informationen zum Diagramm-Block"),
                      ]),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }